import EasyPassClient from './EasyPassClient';

/**
 * @class EasyPassServiceClient
 * @description API wrapper for Tyk Requests towards EasyPass API
 */
class EasyPassServiceClient extends EasyPassClient {
  constructor(user, baseUri, additionalHeaders = {}) {
    super(
      user,
      baseUri || import.meta.env.VITE_TYK_TO_EASY_PASS_BFF_URL,
      {
        ...additionalHeaders,
      },
    );
  }
}

export default EasyPassServiceClient;
